// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-Header-Header-module__item--TvHHp {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.src-components-MainFrame-Header-Header-module__box--p5PYM {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.src-components-MainFrame-Header-Header-module__box--p5PYM > .src-components-MainFrame-Header-Header-module__item--TvHHp {
  border-right: 1px solid #00000014;
}
.src-components-MainFrame-Header-Header-module__titleBox--pGmwf {
  flex: 1;
}
.src-components-MainFrame-Header-Header-module__titleText--U0gpe {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.src-components-MainFrame-Header-Header-module__bellIcon--VzhKi {
  font-size: 18px;
}
.src-components-MainFrame-Header-Header-module__logoBox--sCun2 {
  width: 56px;
  color: #fc4807;
}
.src-components-MainFrame-Header-Header-module__menuBox--bBMDD {
  border-right: none !important;
}
/*# sourceMappingURL=Header.module.css.map */`, "",{"version":3,"sources":["webpack://./Header.module.less","webpack://./src/components/MainFrame/Header/Header.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ACDF;ADIA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;ACFF;ADGE;EACE,iCAAA;ACDJ;ADKA;EACE,OAAA;ACHF;ADMA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACLF;ADQA;EACE,eAAA;ACNF;ADSA;EACE,WAAA;EACA,cAAA;ACPF;ADUA;EACE,6BAAA;ACRF;AACA,4CAA4C","sourcesContent":["@import \"/src/variables.less\";\n\n.item {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n}\n\n.box {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  align-items: center;\n  & > .item {\n    border-right: @borderStd;\n  }\n}\n\n.titleBox {\n  flex: 1;\n}\n\n.titleText {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 120%;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.bellIcon {\n  font-size: 18px;\n}\n\n.logoBox {\n  width: 56px;\n  color: @primary-orange;\n}\n\n.menuBox {\n  border-right: none !important;\n}\n",".item {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n}\n.box {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  align-items: center;\n}\n.box > .item {\n  border-right: 1px solid #00000014;\n}\n.titleBox {\n  flex: 1;\n}\n.titleText {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 120%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.bellIcon {\n  font-size: 18px;\n}\n.logoBox {\n  width: 56px;\n  color: #fc4807;\n}\n.menuBox {\n  border-right: none !important;\n}\n/*# sourceMappingURL=Header.module.css.map */"],"sourceRoot":""}]);
// Exports
export var item = `src-components-MainFrame-Header-Header-module__item--TvHHp`;
export var box = `src-components-MainFrame-Header-Header-module__box--p5PYM`;
export var titleBox = `src-components-MainFrame-Header-Header-module__titleBox--pGmwf`;
export var titleText = `src-components-MainFrame-Header-Header-module__titleText--U0gpe`;
export var bellIcon = `src-components-MainFrame-Header-Header-module__bellIcon--VzhKi`;
export var logoBox = `src-components-MainFrame-Header-Header-module__logoBox--sCun2`;
export var menuBox = `src-components-MainFrame-Header-Header-module__menuBox--bBMDD`;
export default ___CSS_LOADER_EXPORT___;
